<template>
  <v-card width="375" flat class="sct-details mx-auto">
    <back-button v-if="!singlePaymentMethod" @click="$emit('abort')"/>
    <p class="pageTitle">{{$t('wire_transfer')}}</p>
    <p class="pageSubtitle mt-n1 mb-0" >{{$t('details_sct_title')}}</p>
    <p class="pageSubtitle" >{{$t('details_sct_title_2')}}</p>
    
    <div ref="pdfElement" class="print-borderaround">
      <div class="result-table">
        <div class="d-flex divider">
          <div class="formLabel mt-n1">{{$t('iban')}}</div>
          <copyable :label="account.iban"/>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('bic')}}</div>
          <copyable :label="account.bic"/>
        </div>
        <div class="d-flex divider">
          <div class="formLabel">{{$t('beneficiary')}}</div>
          <copyable :label="account.beneficiary"/>
        </div>
        <div class="d-flex divider">
          <div>
            <div class="formLabel">{{$t('motive_transfer')}}</div>
            <span class="formLabel printFormLabel"> ({{$t('motive_proposition')}})</span>
          </div>
          <copyable id="footerContent" :label="account.motif" class="mb-3"/>
        </div>
      </div>
      <pdf-maker :printData="printData" :filePrefix="'sct_details_'" class="hideWhenPrinting mt-6"/>
      <check-box
        class="paymentDetailsCheckbox hideWhenPrinting"
        v-model="conditionChecked"
        :label="$t('accept_saving_of_bank_info')">
      </check-box>
    </div>

    <v-card-actions class="pa-0">
      <ConfirmButton 
        :disabled="!conditionChecked"
        @click="confirm"
        class="icon-button">
        {{$t('confirm')}}
        <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
      </ConfirmButton>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { VCard, VCardActions } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import Copyable from '@/components/Copyable'
  import BackButton from '@/components/BackButton'
  import PdfMaker from '@/components/PdfMaker'
  import CheckBox from '@/components/CheckBox'
  import {mapState} from 'vuex'
  
  export default {
    name: 'PaymentDetailSCT',
    components: { VCard, VCardActions, CheckBox, BackButton, ConfirmButton, PdfMaker, Copyable },
    props: {
      params: {
        type: Object,
        default: () => {}
      }
    },
    mounted: function () {
      this.printData = this.getPrintData()
    },
    methods: {
      confirm: function () {
        this.$emit('confirm', {})
      },
      getPrintData: function () {
        return [
          { text: this.$t('print_sct_title'), class: 'print-title' },
          { text: this.$t('print_sct_title2'), class: 'print-title mb-25' },
          { text: this.$t('print_sct_info'), class: 'print-description' },
          { text: this.$t('print_sct_info2'), class: 'print-description' },
          { element: this.$refs.pdfElement }
        ]
      }
    },
    computed: {
      ...mapState(['singlePaymentMethod']),
      account: function () {
        let transactionData = (this.params && this.params.transactionData) ? this.params.transactionData : {}
        let marketPlaceName = (transactionData && transactionData.payee && transactionData.payee.thirdPartyName) ? transactionData.payee.thirdPartyName : null
        let orderRef = transactionData.orderRef || ((this.params && this.params.mkpData) ? this.params.mkpData.orderRef : '')
        return {
          iban: transactionData.virtualIban || '',
          bic: 'AGRIFRPP777',
          beneficiary: marketPlaceName || '',
          motif: (marketPlaceName ? marketPlaceName + ' - ' : '') + orderRef
        }
      }
    },
    data: function () {
      return {
        conditionChecked: false,
        printData: null
      }
    }
  }
</script>

<style >
</style>